define('models/composer/forms/MultipleChoiceQuestion',[
    'lib/lodash4',
    'lib/knockout',
    'models/composer/forms/BaseQuestion',
    'models/composer/forms/MultipleChoiceQuestionAnswer'
], function (
    _,
    ko,
    BaseQuestionModel,
    MultipleChoiceQuestionAnswerModel
) {
    'use strict';

    var MultipleChoiceQuestionModel = BaseQuestionModel.extend({
        defaults: {
            answerOptions: [{},{},{}], //Init with 3 default multiple choice questions
            answerId: '',
            isCritical: false,
            isKill: false
        },
        modelProperties: {
            answerOptions: MultipleChoiceQuestionAnswerModel
        }
    }, function multiChoiceModel_init () {
        var self = this;

        self.answerOptions.extend({ deferred: true });

        self.answerOptions.subscribe(function (answerOptions) {
            _.each(answerOptions, function(answerOption, index) {
                answerOption.index(index);
            });
        });

        self.addMultipleChoiceQuestionAnswer = function (index, data) {
            data = data || {};
            var newAnswer = new MultipleChoiceQuestionAnswerModel(data);
            if(_.isUndefined(index)) {
                self.answerOptions.push(newAnswer);
            } else {
                self.answerOptions.splice(index, 0, newAnswer);
            }
        };

        // Add an unwrap function to remove all unnecessary properties.
        // toIgnore - {object} OR {array}
        //   {object} - An object that maps which properties to ignore based on the type of the model.
        //     The toIgnore key pertaining to this model would be;
        //       'multipleChoiceQuestion': ['properties', 'to', 'ignore']
        //   OR {array} an array of properties to ignore:
        //       ['properties', 'to', 'ignore']
        self.unwrap = function (toIgnore, options) {
            toIgnore = toIgnore || {};
            options = options || {};
            var typeName = self.type();
            var ignore = [
                'answerOptions',
                'addMultipleChoiceQuestionAnswer'
            ];
            var passToKids = false;
            if (toIgnore instanceof Array) { // if toIgnore is an array
                ignore = ignore.concat(toIgnore || []);
            } else { // if toIgnore is an object mapping
                ignore = ignore.concat(toIgnore[typeName] || []).concat(toIgnore.baseQuestion || []);
                passToKids = true;
            }
            var data = self.baseUnwrap(ignore, options);
            data.answerOptions = _.map(self.answerOptions(), function (submodel) {
                if (self.answerId() === submodel.modelId) {
                    data.answerId = submodel.id;
                }
                return submodel.unwrap(passToKids ? toIgnore : undefined, options);
            });
            return data;
        };

    });

    return MultipleChoiceQuestionModel;
});

